import React from 'react';

import sAction from 'sAction';

import CustomLine from 'ROOT/views/portal/components/detailView/CustomLines/CustomLine';
import Button from 'ROOT/src/components/formElements/Button';
import CustomLinesHeader from 'ROOT/views/portal/components/detailView/CustomLines/CustomLinesHeader';
import CustomLinesTotal from 'ROOT/views/portal/components/detailView/CustomLines/CustomLinesTotal';

import CustomDetailLines_orig from 'ROOT/src/components/detailView/CustomLines/CustomDetailLines';

export default class CustomDetailLines extends CustomDetailLines_orig {
    componentWillMount() {
        const def = this.props.data.get('def');
        const info = this.props.data.get('info');
        const moduleData = this.props.data.get('moduleData');

        this.state.header = (
            <CustomLinesHeader
                def={def}
                moduleData={moduleData}
                info={info}
            />
        );
    }

    getTotal(moduleData, way, lines) {
        return (
            <CustomLinesTotal
                def={this.props.data.get('def')}
                way={way}
                lines={lines}
                moduleData={moduleData}
                info={this.props.data.get('info')}
            />
        );
    }

    render() {
        const info = this.props.data.get('info');
        const way = this.props.way;
        const lines = this.props.data.get('lines');
        const def = this.props.data.get('def');
        const acl = this.props.acl;
        const moduleData = this.props.data.get('moduleData');
        const timeline = this.props.data.get('timeline');
        let index = 0;
        const customLines = [];
        if (lines) {
            lines.forEach((line, key) => {
                if (line.get && line.get('deleted') !== 1 && line.get('deleted') !== '1') {
                    this.keyArray[index] = key;
                    customLines.push(
                        <CustomLine
                            data={line}
                            def={def}
                            key={index}
                            keyV={index}
                            moduleData={moduleData}
                            showError={this.props.data.get('showError')}
                            way={way}
                            canEdit={acl.get('edit')}
                            timeline={timeline}
                            info={info}
                            moveElement={(key, direction) => {
                                this.moveElement(key, direction);
                            }}
                        />,
                    );
                }
                index++;
            });
        }
        this.state.index = index;

        let totalLine = null;
        if (def.get('total') && def.get('total').toJS().length > 0) {
            totalLine = this.getTotal(moduleData, way, lines);
        }

        return (
            <div className='detailCard detailViewTabContent detailQuoteProdComponent'>
                <div className='subpanelsContainer' data-way={this.props.way + '/customData/customLines'}>
                    <div className="qGroupHeaderContainer header">
                        <div className="title">
                            <span className={'detailViewHeaderIcon icon-'} />
                            <span className="detailViewName">
                                {sAction.translate('LBL_MODULE_NAME', info.get('module'))}
                            </span>
                        </div>
                    </div>
                    <div className="detailView">
                        <div className="detailViewTabContent customLines">
                            {this.state.header}
                            {customLines}
                            {totalLine}
                            {acl.get('edit') && (
                                <div className='customLinesRowContainer flexRight viewActionPanelButtons'>
                                    <Button
                                        className="acmButton"
                                        onClick={(e) => this.addCustomLine(def, moduleData)}
                                    >
                                        <div className={'actionPanelButtonIcon icon-addIcon'} />
                                        {sAction.translate('LBL_ADD_CUSTOM_LINE')}
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
